
import {
  isDpaWhite, isRFWhite, isLeadAdsWhite, isEngagementWhite, isCatalogAssetWhite, isRFEngagementWhite,
  isRFAppinstall, isShopWhite, isCreativeHasIdentityWhite, isIOS14MultipleWhite, isIOS14MultipleFiveWhite,
  isMigrationDSAAndCAWhite, isShopCreateDisabled,
} from 'src/const/whiteList';
// import { HELP_CENTER } from '../href';
import { identityTypeMap } from 'src/const/creative/identity';
import store from 'src/store/';
import { Scenario, ShopType } from './shop';

export const campaignType = {
  oldNormalCampaign: 0,
  uncertainCampaign: 1, // 中间态，campaign层级传参
  dedicatedCampaign: 2,
};

// 新的推广类型
export const contentType = { // external_type枚举值
  website: 102,
  app: [201, 202], // android app 和ios app
  brandPureExposure: 12, // 品牌纯曝光
  dpaDeeplink: 501,
  leadAds: 601,
  // 下沉后的 reach/vv 的 external_type 为这个枚举值
  // 表明可能是落地页也可能是品牌纯曝光
  ExternalOrDisplay: 602,
  promotionVideo: -1, // 虚拟的video
};
export const campaignQuotaSum = 11;

export const DCQuotaSum = {
  quotaFive: 5,
  quotaTwo: 2,
  quotaOne: 1,
};
export const getAdgroupDCQuota = () => {
  const isDcQuotaTwo = (isIOS14MultipleWhite() ? DCQuotaSum.quotaTwo : DCQuotaSum.quotaOne);
  return isIOS14MultipleFiveWhite() ? DCQuotaSum.quotaFive : isDcQuotaTwo;
};
// 新的推广类型
export const campaignQuotaConfig = { // campaignQuota三种状态阈值
  insufficient: 3, // 大于0 且小于等于三个，quota不足
  empty: 0, // quota empty
  sufficient: 4, // 大于等于4 quota 充足
};
// export const campaignQuotaNum = 3;
export const deeplinkTypeEnum = {
  productDeepLink: 1,
  customeLink: 2,
};
export const paramsTypes = {
  productDeepLink: 2,
  customeLink: 1,
};
export const externalTypes = [
  {
    label: 'Product DeepLink',
    value: 2,
    i18n_key: 'module_adgroup_product_weblink',
    hint: 'module_adgroup_website_type_product_deepLink_hint',
  },
  {
    label: 'Custome Link',
    value: 1,
    i18n_key: 'module_adgroup_custome_weblink',
    hint: 'module_adgroup_website_type_custome_link_hint',
  },
];
export const deeplinkTypes = [
  {
    label: 'Product DeepLink',
    value: 1,
    i18n_key: 'module_adgroup_product_deepLink',
    hint: 'module_adgroup_deeplink_type_product_deepLink_hint',
  },
  {
    label: 'Custome Link',
    value: 2,
    i18n_key: 'module_adgroup_custome_link',
    hint: 'module_adgroup_deeplink_type_custome_link_hint',
  },
];
export const fallBackTypeEnum = {
  fallbackApp: 1,
  fallbackWeb: 2,
  // fallbackWebCustome: 3, // 这个值
};
export const deeplinkWebFallBackTypes = { // dpa deeplink的fallback website的url类型
  catalogueLink: 2,
  customeLink: 1,
  defalutLink: 0,
};
export const trafficFallBackTypes = [
  {
    value: 1,
    i18n_key: 'module_adgroup_traffic_fallback_app',
    hint: 'module_adgroup_traffic_fallback_app_hint',
  },
  {
    value: 2,
    i18n_key: 'module_adgroup_traffic_fallback_website',
    hint: 'module_adgroup_traffic_fallback_website_hint',
  },
];
export const fallBackTypes = [
  {
    value: 1,
    i18n_key: 'module_adgroup_deepLink_fallback_app',
    hint: 'module_adgroup_deepLink_fallback_app_hint',
  },
  {
    value: 2,
    i18n_key: 'module_adgroup_deepLink_fallback_website_product',
    hint: 'module_adgroup_deepLink_fallback_website_product_hint',
  },
  // { // 这个类型不存在是根据external url和deeplinkWebFallBackTypes算出来的,这个值只供前端展示用
  //   value: 3,
  //   i18n_key: 'module_adgroup_deepLink_fallback_website_custome',
  //   hint: 'module_adgroup_deepLink_fallback_website_custome_hint',
  // },
];
export const promotionTypes = [
  {
    key: 'deep-link',
    label: 'Deeplink',
    i18n_key: 'module_adgroup_deeplink',
    value: contentType.dpaDeeplink,
    // icon: 'promotion-deeplink',
    icon: 'dpa-deeplink',
    hint: 'module_adgroup_deeplink_hint',
  },
  {
    key: 'app-install',
    label: 'AppInstall',
    value: [...contentType.app],
    i18n_key: (isDpa, isNewStructure) => {
      if (isDpa) {
        return isNewStructure ? 'module_dpa_adgroup_objective_app' : 'module_dpa_adgroup_objective_app_install';
      }
      return 'adgroup_promote_app';
    },
    icon: 'dpa-app',
    hint: 'module_adgroup_objective_app_hint',
  },
  {
    key: 'website',
    label: 'Website',
    i18n_key: 'module_adgroup_objective_landingpage',
    value: contentType.website,
    icon: 'dpa-website',
    hint: 'module_adgroup_objective_landingpage_hint',
  },
  {
    key: 'video',
    label: 'video',
    i18n_key: 'module_adgroup_promotion_video',
    value: contentType.promotionVideo,
    icon: 'video-view',
    hint: 'module_adgroup_promotion_video_hint',
  },
];
// 品牌广告专属的推广目的类型,
export const brandLandingType = {
  PURE_SHOW: 7, // 纯展示
};

// 预算类型
export const budgetMode = {
  NO_LIMIT: -1, // 不限
  // 日预算
  DAY_BUDGET: 0,
  // 总预算
  TOTAL_BUDGET: 1,
};
// 广告组状态选项
export const campaignStatus = {
  NONE: '',
  NO_DELETE: 'no_delete',
  ENABLE: 'delivery_ok',
  NOT_DELIVERY: 'not_delivery',
  PAUSE: 'disable',
  DELETE: 'delete',
};
export const campaignObjectiveValue = {
  Reach: 5,
  Traffic: 1,
  Conversion: 3,
  AppInstall: 2,
  VideoView: 4,
  DPA: 6,
  RF: 7,
  LeadAds: 8,
  Engagement: 9,
  RF_VV: 10,
  RF_TRAFFIC: 11,
  RF_ENGAGEMENT: 12,
  RF_APPINSTALL: 13,
  Shop: 14,
};
export const rfObjectiveName = {
  [campaignObjectiveValue.RF]: 'reach',
  [campaignObjectiveValue.RF_VV]: 'vv',
  [campaignObjectiveValue.RF_TRAFFIC]: 'traffic',
  [campaignObjectiveValue.RF_ENGAGEMENT]: 'EO',
  [campaignObjectiveValue.RF_APPINSTALL]: 'APPInstall',
};
export const campaignObjective = {
  Auction: {
    Awareness: {
      label: 'Awareness',
      i18n_key: 'campaign_objective_awareness',
      children: [
        {
          label: 'Reach',
          i18n_key: 'campaign_objective_reach',
          value: campaignObjectiveValue.Reach,
          icon: 'objective-reach',
          hint: 'campaign_objective_reach_hint',
          hidden: () => false,
          iconName: 'reach',
        },
      ],
      hidden: () => false,
    },
    Consideration: {
      label: 'Consideration',
      i18n_key: 'campaign_objective_consideration',
      hidden: () => false,
      children: [
        {
          label: 'Traffic',
          value: campaignObjectiveValue.Traffic,
          i18n_key: 'campaign_objective_traffic',
          icon: 'objective-traffic',
          hint: 'campaign_objective_traffic_hint',
          hidden: () => false,
          iconName: 'traffic',
        },
        {
          label: 'App Install',
          i18n_key: 'campaign_objective_appInstall',
          value: campaignObjectiveValue.AppInstall,
          icon: 'objective-app',
          hint: 'campaign_objective_appInstall_hint',
          hidden: () => false,
          iconName: 'app-install',
        },
        {
          label: 'Video View',
          i18n_key: 'campaign_objective_videoview',
          value: campaignObjectiveValue.VideoView,
          icon: 'objective-video',
          hint: 'campaign_objective_videoview_hint',
          hidden: () => false,
          iconName: 'video-view',
        },
        {
          label: 'Lead Ads',
          i18n_key: 'campaign_objective_lead_ads',
          value: campaignObjectiveValue.LeadAds,
          icon: 'objective-leadads',
          hint: 'campaign_objective_lead_ads_hint',
          hidden: () => !isLeadAdsWhite(),
          iconName: 'lead-ads',
        },
        {
          label: 'Engagement',
          i18n_key: 'campaign_objective_engagement',
          value: campaignObjectiveValue.Engagement,
          icon: 'objective-engagement',
          hint: 'campaign_objective_engagement_hint',
          hidden: () => !isEngagementWhite(),
          hasNewIconOnly: true,
          iconName: 'engagement',
        },
      ],
    },
    Conversion: {
      label: 'Conversion',
      i18n_key: 'campaign_objective_conversion_title',
      children: [
        {
          label: 'Conversion',
          i18n_key: 'campaign_objective_conversion',
          value: campaignObjectiveValue.Conversion,
          icon: 'objective-conversion',
          hint: 'campaign_objective_conversion_hint',
          hidden: () => false,
          iconName: 'conversions',
        },
        {
          label: 'dpa',
          i18n_key: 'module_campaign_objective_dpa',
          value: campaignObjectiveValue.DPA,
          icon: 'objective-dpa',
          hint: 'module_dpa_catalog_sales_label',
          hidden: () => !isDpaWhite() || !isCatalogAssetWhite() || isMigrationDSAAndCAWhite(),
          hoverTips: {
            text: 'module_dpa_catalog_sales_hint',
            placement: 'top',
          },
          iconName: 'dpa',
        },
        {
          label: 'shop',
          i18n_key: 'module_campaign_objective_shop',
          value: campaignObjectiveValue.Shop,
          icon: 'objective-shop',
          hint: 'module_objective_shop_hit',
          hidden: () => (!isShopWhite() || !isCreativeHasIdentityWhite()) && !store.state.shop.hasMagellanShop || isShopCreateDisabled(),
          iconName: 'shop',
          isBeta: true,
        },
      ],
      hidden: () => false,
    },
  },
  RF: {
    Awareness: {
      label: 'Awareness',
      i18n_key: 'campaign_objective_awareness',
      children: [
        {
          label: 'Reach',
          i18n_key: 'campaign_objective_reach',
          value: campaignObjectiveValue.RF,
          icon: 'objective-reach',
          hint: 'campaign_objective_reach_hint',
          hidden: () => !isRFWhite(),
          iconName: 'reach',
        },
      ],
      hidden: () => false,
    },
    Consideration: {
      label: 'Consideration',
      i18n_key: 'campaign_objective_consideration',
      children: [
        {
          label: 'Traffic',
          i18n_key: 'campaign_objective_traffic',
          value: campaignObjectiveValue.RF_TRAFFIC,
          icon: 'objective-traffic',
          hint: 'campaign_objective_traffic_hint',
          hidden: () => !isRFWhite(),
          iconName: 'traffic',
        },
        {
          label: 'App Install',
          i18n_key: 'campaign_objective_appInstall',
          value: campaignObjectiveValue.RF_APPINSTALL,
          icon: 'objective-app',
          hint: 'campaign_objective_appInstall_hint',
          hidden: () => !isRFWhite() || !isRFAppinstall(),
          iconName: 'app-install',
        },
        {
          label: 'Video View',
          i18n_key: 'campaign_objective_videoview',
          value: campaignObjectiveValue.RF_VV,
          icon: 'objective-video',
          hint: 'campaign_objective_videoview_hint',
          hidden: () => !isRFWhite(),
          iconName: 'video-view',
        },
        {
          label: 'Engagement',
          i18n_key: 'campaign_objective_engagement',
          value: campaignObjectiveValue.RF_ENGAGEMENT,
          icon: 'objective-engagement',
          hint: 'campaign_objective_engagement_hint',
          hidden: () => !isRFWhite() || !isRFEngagementWhite(),
          hasNewIconOnly: true,
          iconName: 'engagement',
        },
      ],
      hidden: () => false,
    },
  },
};

/**
 * 获取 objective（campaign planer 限制只开放 R&F）
 * @returns 返回满足条件的 objective
 */
export const getObjectiveList = () => {
  const { RF } = campaignObjective;
  const children = Object.values(RF).reduce((p, c) => p.concat(c.children), []);
  return children.filter(item => !item.hidden());
};

export const openUrl = {
  enableOpenUrl: 1,
  disableOpenUrl: 0,
};

export const campaignObjectiveI18nKey = {
  [campaignObjectiveValue.Reach]: 'campaign_objective_reach',
  [campaignObjectiveValue.Traffic]: 'campaign_objective_traffic',
  [campaignObjectiveValue.Conversion]: 'campaign_objective_conversion',
  [campaignObjectiveValue.AppInstall]: 'campaign_objective_appInstall',
  [campaignObjectiveValue.VideoView]: 'campaign_objective_videoview',
  [campaignObjectiveValue.DPA]: 'module_campaign_objective_dpa',
  [campaignObjectiveValue.LeadAds]: 'campaign_objective_lead_ads',
  [campaignObjectiveValue.Engagement]: 'campaign_objective_engagement',
  [campaignObjectiveValue.Shop]: 'module_campaign_objective_shop',
  [campaignObjectiveValue.RF]: 'campaign_objective_reach',
  [campaignObjectiveValue.RF_VV]: 'campaign_objective_videoview',
  [campaignObjectiveValue.RF_TRAFFIC]: 'campaign_objective_traffic',
  [campaignObjectiveValue.RF_ENGAGEMENT]: 'campaign_objective_engagement',
  [campaignObjectiveValue.RF_APPINSTALL]: 'campaign_objective_appInstall',
};


// 用于埋点的Objective标识key
export const campaignObjectiveKey = {
  [campaignObjectiveValue.Reach]: 'Reach',
  [campaignObjectiveValue.Traffic]: 'Traffic',
  [campaignObjectiveValue.Conversion]: 'Conversion',
  [campaignObjectiveValue.AppInstall]: 'App install',
  [campaignObjectiveValue.VideoView]: 'Video view',
  [campaignObjectiveValue.DPA]: 'Catalog',
  [campaignObjectiveValue.LeadAds]: 'LeadAds',
  [campaignObjectiveValue.Engagement]: 'Engagement',
  [campaignObjectiveValue.Shop]: 'Shop',
};
// campaign list 新增filterOptions
export const campaignTypeSearch = [
  {
    key: 'enum_campaign_dedicate_type_2',
    id: 2,
  },
  {
    key: 'enum_campaign_dedicate_type_0',
    id: [0, 1],
  },
];
// 列表搜索
export const campaignObjectiveSearch = [
  {
    key: 'campaign_objective_conversion',
    id: 3,
  },
  {
    key: 'campaign_objective_traffic',
    id: [1, 11],
  },
  {
    key: 'campaign_objective_appInstall',
    id: [2, 13],
  },
  {
    key: 'campaign_objective_videoview',
    id: [4, 10],
  },
  {
    key: 'campaign_objective_reach',
    id: [5, 7],
  },
  {
    key: 'module_campaign_objective_dpa',
    id: 6,
    hidden: () => !isDpaWhite(),
  },
  {
    key: 'module_campaign_objective_shop',
    id: 14,
    hidden: () => !isShopWhite(),
  },
  {
    key: 'campaign_objective_lead_ads',
    id: 8,
    hidden: () => !isLeadAdsWhite(),
  },
  {
    key: 'campaign_objective_engagement',
    id: [9, 12],
    hidden: () => !isEngagementWhite() && !isRFWhite(),
  },
];
export const campaignBuyingTypeSearch = [
  {
    key: 'campaign_auction',
    id: [2, 3],
  },
  {
    key: 'module_campaign_rf',
    id: 4,
    hidden: () => !isRFWhite(),
  },
];

export const campaignCBOTypeSearch = [
  {
    key: 'campaign_use_cbo',
    id: 1,
  },
  {
    key: 'campaign_no_use_cbo',
    id: 0,
  },
];

/* eslint-disable */
export const formatAge = (arr) => { //后端回传的数据结构为[[18,24], [23,34]],前端的数据结构为[“18,24”, “23,34”]
  return arr.map(item => {
    if (typeof item === 'string') {
      return String(item).split(',');
    }
    return item;
  });
};
// 处理一下wifi类型的函数
export const formatAc = (arr) => {
  let tempArr = [...arr];
  if (arr.length === 1 && arr[0] === 'ALL') {
    tempArr = [];
  }
  return tempArr;
};

export const formatPlatForm = (item) => {
  if (!Array.isArray(item)) {
    return [item]
  }
  return item;
}

// 创编页面退出时打点adgroupData参数打平配置文件
export const adgroupDataMap = {
  adgroup_data_placement: 'inventory_flow',
  adgroup_data_apporwebsite: 'content_type',
  adgroup_data_website_link: 'external_url',
  adgroup_data_app_link: 'download_url',
  adgroup_data_app_type: 'app_type',
  adgroup_data_app_displayname: 'app_name',
  adgroup_data_category: 'ad_category',
  adgroup_data_tags: 'ad_keywords',
  adgroup_data_comment: 'is_comment_disable',
  adgroup_data_automated_creative: 'creative_material_mode',
  adgroup_data_particle_locations: 'particle_locations',
  adgroup_data_gender: 'gender',
  adgroup_data_age: 'age',
  adgroup_data_languages: 'language_list',
  adgroup_data_interest: 'ad_tag_v2',
  adgroup_data_connection: 'ac',
  adgroup_data_carriers: 'carriers',
  adgroup_data_device_type: 'device_type',
  adgroup_data_device_pricerange: 'launch_price',
  adgroup_data_android_versions: 'android_osv',
  adgroup_data_ios_versions: 'ios_osv',
  adgroup_data_budget_mode: 'budget_mode',
  adgroup_data_budget_number: 'budget',
  adgroup_data_schedule_type: 'schedule_type',
  adgroup_data_schedule_start: 'start_time',
  adgroup_data_schedule_end: 'end_time',
  adgroup_data_dayparting: 'period',
  adgroup_data_optimization_goa: 'pricing',
  adgroup_data_smart_optimization: 'cpa_skip_first_phrase',
  adgroup_data_learning_bid: 'bid',
  adgroup_data_cpa_bid: 'cpa_bid',
  adgroup_data_delivery_type: 'flow_control_mode',
  adgroup_data_impression_tracking: 'track_url',
  adgroup_data_click_tracking: 'action_track_url',
  adgroup_data_retargeting_tags: 'retargeting_tags',
  adgroup_data_retargeting_tags_exclud: 'retargeting_tags_exclude',
  adgroup_data_app_convert_id: 'convert_id',
  adgroup_data_objective_type: 'objective_type',
};
export const adRouteMap = {
  'ad-campaign-create': 'campaign',
  'ad-group-create': 'ad_group',
  'ad-create': 'ad',
  // TODO: 【url 下沉】确认下埋点下沉前后是否要区分，现在是未做区分
  'ad-creation': 'ad',
};
export const adCreateEvent = {
  'ad-campaign-create': 'create_enter_campaign',
  'ad-group-create': 'create_enter_adgroup',
  'ad-create': 'create_enter_ad',
  // TODO: 【url 下沉】确认下埋点下沉前后是否要区分，现在是未做区分
  'ad-creation': 'create_enter_ad',
};
export const splitTestType = {
  // 标记创建流程中设置开启 split test，需要完成实验组绑定才能生效
  UNINITIALIZED: -1,
  NONE: 0,
  TARGET: 1,
  CREATIVE: 2,
  OPTIMIZE: 3,
};

export const pangleFlowPackConfig = {
  orient: {
    type: 'ORIENT',
    value: 1,
    lable_i18n: 'common_flow_orient'
  },
  exclude: {
    type: 'EXCLUDE',
    value: 2,
    lable_i18n: 'common_flow_exclude'
  }
};

export const checkIsRFRefactorObj = (objectiveType) => {
  return [campaignObjectiveValue.RF,campaignObjectiveValue.RF_VV,campaignObjectiveValue.RF_TRAFFIC,].includes(+objectiveType)
}

// 使用此方法判断RF类型
export const checkIsRF = (objectiveType) => {
  return [campaignObjectiveValue.RF, campaignObjectiveValue.RF_VV, campaignObjectiveValue.RF_TRAFFIC,
  campaignObjectiveValue.RF_ENGAGEMENT, campaignObjectiveValue.RF_APPINSTALL].includes(+objectiveType)
}

export const checkIsVV = (objectiveType) => {
  return [campaignObjectiveValue.VideoView, campaignObjectiveValue.RF_VV].includes(objectiveType)
}

export const checkIsShop = (objectiveType) => +objectiveType === campaignObjectiveValue.Shop;
export const checkIsLiveShopping = (externalType) => externalType === Scenario.Live;

/**
 * 使用创编的类型
 * 用于区分一般的创编还是 campaign planer 加载的创编
 */
export const CREATION_TYPE = {
  normal: 1,
  campaignPlaner: 2,
};

export const bulkOperationByType = {
  value: 1, // 批量操作设置值
  percentage: 2, // 批量操作设置百分比
};
export const bulkOperationType = {
  value: 1, // 批量操作设置值
  increase: 2, // 批量调高
  decrease: 3, // 批量调低
};

export const BulkAdjustValueMap = {
  campaignName: {
    original_key: 'campaign_name',
    adjust_key: 'adjustCampaignName',
    budget_mode_key: 'campaign_budget_mode',
    error_map_key: 'campaign_name_error_map'
  },
  campaignBudget: {
    original_key: 'campaign_budget',
    adjust_key: 'adjustCampaignBudget',
    budget_mode_key: 'campaign_budget_mode',
    error_map_key: 'campaign_budget_error_map'
  },
  adgroupName: {
    original_key: 'ad_name',
    adjust_key: 'adjustAdgroupName',
    budget_mode_key: 'budget_mode',
    error_map_key: 'ad_name_error_map'
  },
  budget: {
    original_key: 'budget',
    adjust_key: 'adjustBudget',
    budget_mode_key: 'budget_mode',
    error_map_key: 'ad_budget_err_map'
  },
  bid: {
    original_key: 'bid',
    adjust_key: 'adjustBid',
    budget_mode_key: 'budget_mode',
    error_map_key: 'ad_bid_err_map'
  },
};

export const getIosAppImg = (currentLang) => {
  const supportLang = ['zh', 'ja', 'en', 'ar'];
  if (supportLang.indexOf(currentLang) >= 0) {
    return require(`src/assets/images/ios-trend-${currentLang}.png`);
  }
  return require('src/assets/images/ios-trend-en.png');
};

// 创编来源
export const REFERER = {
  STORE_MANAGER: {
    value: 'tt_store_manager',
    queryFields: ['aadvid', 'objective_type', 'shop_id', 'spu_id'],
    objectiveType: campaignObjectiveValue.Shop,
  },
  MAGELLAN: {
    value: 'tts',
    objectiveType: campaignObjectiveValue.Shop,
  },
  // pixel event 隐藏后的switch now
  SWITCH_TO_CONVERSION_SHORTCUT:{
    value: 'switch_to_conversion_shortcut',
    queryFields: ['aadvid', 'objective_type'],
    objectiveType: campaignObjectiveValue.Conversion,
  }
}
export const buyingType = {
  AUCTION: 1,
  RF: 2,
}

// 资产对应的枚举值
export const assetsValue = {
  product_platform_id: 1,
  ad_ref_pixel_id: 2,
  [`${ShopType.ecommShop}_shop_id`]: 4,
  [`${ShopType.tt4bShop}_shop_id`]: 5,
  identity_id: 6
}

// 资产对应的字段名字
export const assetFieldValue = [
  'shop_id', // shop
  'identity_id', // identity
  'ad_ref_pixel_id', // pixel
  'product_platform_id' // catalog
];

export const assetLabelValue = {
  [assetsValue.product_platform_id]: 'Catalog ID',
  [assetsValue.ad_ref_pixel_id]: 'Pixel ID',
  [assetsValue[`${ShopType.ecommShop}_shop_id`]]: 'Shop ID',
  [assetsValue[`${ShopType.tt4bShop}_shop_id`]]: 'Shop ID',
  [assetsValue.identity_id]: 'module_creative_tiktok_account'
}
// 判断资产字段值是否有效
export const handleValidAssetsField = (fieldName, value, formData) => {
  const validValue = (!!value && value !== '0');
  if(fieldName === 'identity_id') { // identity假账号不在资产限制范围
    const { identity_type } = formData;
    return identity_type !== identityTypeMap.FAKE_USER && validValue;
  }
  return validValue;
}

// 根据formdata的字段值判断使用到哪些资产
export const getAssetsField = (formData = {}, excludeAssetFieldArr = []) => {
  return assetFieldValue.filter(assetsName => !excludeAssetFieldArr.includes(assetsName) && handleValidAssetsField(assetsName, formData[assetsName], formData))
  .map((assetsName) => {
    /*
      资产查询区分shop 1p和3p
    */
      const assetId = formData[assetsName];
      if(assetsName === 'shop_id' && formData?.shop_type) {
        assetsName = `${formData?.shop_type}_shop_id`
      }
      return {
        asset_id: assetId,
        asset_type: assetsValue[assetsName]
      }
  })
}

// 动态计算资产剩余额度，返回小于5%额度的资产
export const computedAssetsNum = (
  assetsInfo = [], adGroupNum = 1, adGroupAssets = [],
  creativeNum = 1, creativeAssets = [], limit = 0.05
  ) => {
    try {
            // adgroup层级的资产使用情况
      let adGroupAssetsMap = adGroupAssets.reduce((pre, asset) => {
        pre[asset.asset_id] = adGroupNum;
        return pre;
      }, {});
      // adgroup层级和creative层级资产使用情况
      let allAssetsMap = creativeAssets.reduce((pre, asset) => {
        if(!pre[asset.asset_id]){
          pre[asset.asset_id] = creativeNum;
        }else {
          pre[asset.asset_id] += creativeNum;
        }
        return pre;
      }, adGroupAssetsMap);
      return assetsInfo.filter((asset) => {
        // availableQuota默认值设置1000，防止出错不影响主流程
        const availableQuota = asset?.available_quota ?? 1000;
        const usedQuota = allAssetsMap[asset.id] ?? 0;
        const totalQuota = asset?.total_quota ?? 1000;
        return (availableQuota - usedQuota)/totalQuota < limit;
      }).map(asset => ({
        assetId: asset.id,
        availableNum: asset.available_quota,
        assetName: assetLabelValue[asset.asset_type]
      }))
    }catch (e) {
      return [];
    }
}

// 哪些推广系列可以使用上下文定向
export const CONTEXT_TARGET_OBJECTIVE_TYPES = [
  campaignObjectiveValue.RF,
  campaignObjectiveValue.RF_VV,
];
